import { FC, useEffect, useState } from 'react';

import dayjs from 'dayjs';

import { QuestionsCircleIcon } from '../../icons/question-circle';
import Button from '../../common/button';
import { SettingsButton } from '../../icons/settings-button';
import { getTimeTzNoLess } from '../../../utils/getTime';
import { PlusIcon } from '../../icons/plus';
import { CalendarIcon } from '../../icons/calendar';
import { IClient, IConsultation } from '../../../store/types';
import { ConsultationCard } from '../consultation-card';
import Tooltip from '../../common/tooltip';
import { UploadAudioWidget } from '../../common/upload-audio-widget';

type ConsultationTableProps = {
  setOpenSettings: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenCalendar: React.Dispatch<React.SetStateAction<boolean>>;
  openForm: () => void;
  consultationList: IConsultation[];
  clientsList: Pick<IClient, 'id' | 'full_name' | 'time_zone'>[];
  handleChangeCons: (
    id: number,
    options?: { isEdit?: boolean; overrideStart?: string; overrideEnd?: string; overrideDate?: string },
  ) => void;
  handleOpenDelete: (item: IConsultation, isCalendar: boolean) => void;
  openEditFormClient: (id: number) => void;
  sortConsultation: () => void;
};

export const ConsultationTable: FC<ConsultationTableProps> = ({
  setOpenSettings,
  setOpenCalendar,
  handleChangeCons,
  openForm,
  openEditFormClient,
  consultationList,
  clientsList,
  sortConsultation,
  handleOpenDelete,
}) => {
  const [time, setTime] = useState(getTimeTzNoLess(new Date()));

  useEffect(() => {
    //Implementing the setInterval method
    const interval = setInterval(() => {
      setTime(getTimeTzNoLess(new Date()));
    }, 1000);

    //Clearing the interval
    return () => clearInterval(interval);
  }, [time]);

  return (
    <div className="flex flex-col gap-10 sm:gap-3 w-full h-full">
      <div className="w-full flex flex-col gap-[30px] sm:flex-row justify-between relative">
        <div className="flex gap-4 items-center ">
          <h1 className="font-comfortaa font-semibold text-lg sm:text-2xl text-blackBase">Консультации</h1>
          <Tooltip text="На странице отображаются встречи на СЕГОДНЯ, остальные – в Календаре встреч.">
            <QuestionsCircleIcon width={21} height={21} />
          </Tooltip>
        </div>
        <Button
          type={'black'}
          onClick={() => setOpenSettings(true)}
          className="hidden h-[40px] items-center gap-5 !py-0 !text-sm !font-medium !leading-4 sm:flex sm:w-max sm:!text-base"
        >
          <SettingsButton className="fill-white group-hover:fill-redBase" />
          Настройки
        </Button>
      </div>
      <div className="px-5 pb-5 pt-6 flex flex-col sm:flex-row justify-between w-full h-full gap-5 bg-[#F6F6F6] rounded-[30px_30px_0px_0px]">
        <div className="w-full sm:max-w-[180px] flex flex-col gap-[30px]">
          <div className="grid grid-cols-2 gap-5 sm:flex sm:flex-col sm:gap-[30px]">
            <div className="flex h-[126px] w-full flex-col rounded-[20px] bg-white px-4 py-5 sm:max-w-[180px] sm:px-[30px]">
              <p className="text-[#a09fa7] text-sm mb-[5px]">Сегодня</p>
              <p className="text-redBase text-2xl font-semibold mb-2.5">{time}</p>
              <p className="whitespace-nowrap text-base font-medium text-[#111026]">{dayjs().format('DD.MM.YYYY, dd')}</p>
            </div>
            <Button
              className="!text-sm w-full sm:max-w-[180px] h-[126px] font-bold group flex flex-col items-center justify-center gap-[5px] rounded-[20px]"
              onClick={() => setOpenCalendar((prev) => !prev)}
            >
              <CalendarIcon className="stroke-white" />
              Календарь встреч
            </Button>
          </div>
          <Button
            className="!text-sm w-full sm:max-w-[180px] font-bold group flex flex-col items-center justify-center gap-[5px] rounded-[20px]"
            onClick={() => openForm()}
          >
            <PlusIcon className="stroke-white" />
            Создать встречу
          </Button>
          <UploadAudioWidget clientNames={clientsList.map((c) => c.full_name).filter(Boolean)} />
        </div>
        <div className="w-full h-full flex flex-col gap-10 pb-5 min-w-0">
          {consultationList?.map((item, idx) => {
            const client = clientsList.find((el) => `/api/v1/clients/${el.id}` === item.client_entity);

            return (
              <ConsultationCard
                openEditFormClient={openEditFormClient}
                item={item}
                handleChangeCons={handleChangeCons}
                handleOpenDelete={handleOpenDelete}
                client={client}
                key={idx}
                sortConsultation={sortConsultation}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};
